import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';
export default function UIRouterLink(props) {
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, props, {
    component: UILink
  }));
}

const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
      sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);

UIRouterLink.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, {}, clonePropTypes(UILink));
UIRouterLink.defaultProps = cloneDefaultProps(UILink);